<!-- 编辑设备详情弹框 -->
<template>
  <div class="edit-container">
    <el-scrollbar style="height: 100%">
      <ioc-forms
        ref="iocForm"
        v-model="devInData"
        :formData="devInData"
        :option="devInData.deviceType === '18' ? devInOption : devInOption2"
      >
        <template slot="isIndoor">
          <el-select v-model="devInData.isIndoor" @change="selectChange">
            <el-option
              v-for="item in isIndoorList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="longitude">
          <div>
            <el-input
              v-model="devInData.longitude"
              placeholder="请选择室外位置"
              class="position-set"
              readonly
            ></el-input>
            <el-button
              type="text"
              size="small"
              style="position: absolute; right: 0px; font-size: 18px; top: -3px"
              class="iconfont icon-position choose-person"
              @click="openMap"
              title="选择位置"
            ></el-button>
          </div>
        </template>
        <template slot="latitude">
          <div>
            <el-input
              v-model="devInData.latitude"
              class="position-set"
              readonly
              placeholder="请选择室外位置"
            ></el-input>
            <el-button
              type="text"
              size="small"
              style="position: absolute; right: 0px; font-size: 18px; top: -3px"
              class="iconfont icon-position choose-person"
              @click="openMap"
              title="选择位置"
            ></el-button>
          </div>
        </template>
        <template slot="BuildingName">
          <div>
            <el-input
              readonly
              v-model="devInData.buildName"
              class="position-set"
              placeholder="请标记室内位置"
            ></el-input>
            <el-button
              type="text"
              size="small"
              style="position: absolute; right: 0px; font-size: 18px; top: -3px"
              class="iconfont icon-position choose-person"
              @click="openBuilding"
              title="选择楼栋"
            ></el-button>
          </div>
        </template>
        <template slot="password">
          <div>
            <el-input
              show-password
              auto-complete="off"
              v-model="devInData.password"
              placeholder="请输入设备密码"
            ></el-input>
          </div>
        </template>
      </ioc-forms>
    </el-scrollbar>

    <!--选择设备树-->
    <el-dialog
      v-ops:width="380"
      :title="$t('cameraList.title.chooseArea')"
      width="30%"
      v-dialogDrag
      :visible.sync="deviceTreeShow"
      center
      :modal="false"
    >
      <el-tree
        :data="areaTrData"
        :highlight-current="true"
        :props="defaultProps"
        @node-click="selectAreaNode"
      ></el-tree>
    </el-dialog>
    <!-- 引入gis地图 -->
    <el-dialog
      v-dialogDrag
      title="选择位置"
      width="65%"
      :visible.sync="showMap"
      @close="mapCancleOpt"
      :modal="false"
    >
      <div id="map-container" ref="miniMap">
        <appMap ref="refAppMap" divId="miniMap"></appMap>
      </div>
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="mapCancleOpt">{{ $t("taskCenter.button.cancel") }}</el-button>
        <el-button type="primary" @click="mapConfirmOpt">{{
          $t("taskCenter.button.conform")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 楼栋树 -->
    <el-dialog
      title="楼栋选择"
      width="70%"
      v-dialogDrag
      :visible.sync="showBuilding"
      @close="mapClose"
      :modal="false"
      @click="mapCancleOpt"
    >
      <!--左侧楼栋树-->
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <div class="left-type_area">
            <div class="tree-container">
              <div class="area-title">楼栋信息</div>
              <div class="area-search">
                <el-input
                  v-model="searchString"
                  clearable
                  placeholder="请输入搜索关键字"
                  prefix-icon="el-icon-search"
                >
                </el-input>
              </div>
              <el-scrollbar class="scroll-bar-view" style="height: 600px">
                <el-tree
                  ref="tree"
                  class="tree-content"
                  :data="treeData"
                  :expand-on-click-node="false"
                  node-key="id"
                  :default-expanded-keys="expandedKeys"
                  :props="treeProps"
                  :highlight-current="true"
                  :filter-node-method="filterNode"
                  @node-click="nodeClick"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>

        <!--右侧展示图纸-->
        <!-- 右侧图纸 -->
        <div class="right-img">
          <div class="canvasMain">
            <div
              class="canvasMainT"
              :style="{
                width: vW + '%',
                height: vH + '%',
                marginTop: getMarginTop + 'px',
                marginLeft: getMarinLeft + 'px',
              }"
            >
              <img
                id="building-img"
                :src="
                  rootDefaultDrawing
                    ? '/images/theme/newDark/default-drawing1.jpg'
                    : imgUrl
                "
              />
              <canvas
                id="mycanvas"
                style="cursor: all-scroll"
                @mousewheel="mouseScroll"
                @DOMMouseScroll="mouseScroll"
                @mousedown="handleDomMoveStart"
                :width="cW"
                :height="cH"
              ></canvas>
            </div>
          </div>
        </div>
        <div class="coord">
          <span> 【 缩放比例 {{ vW }}% 】 </span>
          【相对坐标 X：{{ x }} ，Y：{{ y }} 】
        </div>
      </div>

      <!--操作按钮-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="camCancelOpt">取消</el-button>
        <el-button type="primary" @click="camConfirmOpt">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import { Bus } from "$utils";
import deviceMap from "../components/deviceMap";
import appMap from "@src/components/common/gis/index";
// import appPanel from "@src/components/business/app-panel/index.vue";
import { editDev, editDev1 } from "../const/editDev";
export default {
  components: {
    appMap,
    // appPanel
  },
  data() {
    return {
      isDisplay: {
        display: false,
      },
      isNoDisplay: {
        display: false,
      },
      isShow: false,
      isIndoorList: [
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      rootDefaultDrawing: true,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
        id: "id",
      },
      x: "",
      y: "",
      imgUrl: "",
      showTree: true,
      buildingCode: "",
      showBuilding: false,
      treeData: [],
      searchString: "",
      expandedKeys: [],
      lazyLoad: false,
      cW: 0,
      cH: 0,
      canvasList: [],
      treeDate: [],
      devInData: {},
      deviceTreeShow: false,
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      // 区域树对象
      areaTrData: [],
      devInOption: editDev(this, 0), //摄像机配置
      devInOption2: editDev(this, 1), //非摄像机配置
      showMap: false,
      point: {},
      setTimeNum: 0,
      tipImg: {},
      handleClickTime: null,
    };
  },

  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  mixins: [deviceMap],
  watch: {
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    devInData: {
      handler(val) {
        // console.log(val);
        if (val?.isIndoor == 0 || val?.isIndoor == 1) {
          // 人脸闸机
          // if (val.deviceType == 22) {
          //   this.$refs.iocForm.option.column[17].display = true;
          // }
          setTimeout(() => {
            this.$forceUpdate();
            this.selectChange(val?.isIndoor);
          }, 300);
        }
      },
      deep: true,
      immediate: true,
    },
    searchString: {
      handler(val) {
        this.$refs.tree.filter(val);
      },
    },
    showBuilding(newVal) {
      if (newVal == false) {
        this.clearCanvas();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.handleClickTime);
    window.onresize = null;
  },
  mounted() {
    this.tipImg[18] = new Image();
    this.tipImg[18].src = require("/public/images/theme/newDark/map/cameraDefault.png");
    this.tipImg[26] = new Image();
    this.tipImg[26].src = require("/public/images/theme/newDark/map/resource/broadcast_inactive.png");
    this.tipImg[10001] = new Image();
    this.tipImg[10001].src = require("/public/images/theme/newDark/map/default_device.png");
    this.getAreaTree();
    setTimeout(() => {
      console.log(this.$refs.iocForm.option);
    }, 500);
  },
  methods: {
    //输入框选择是否在室内，否：关经纬度，显示楼栋，是：开经纬度，关楼栋
    selectChange(val) {
      if (val == 1) {
        // 室内
        this.$refs.iocForm.option.column[12].display = false;
        this.$refs.iocForm.option.column[13].display = false;
        this.$refs.iocForm.option.column[14].display = true;
        this.$refs.iocForm.option.column[15].display = true;
        this.$refs.iocForm.option.column[16].display = true;
      } else {
        // 室外
        this.$refs.iocForm.option.column[12].display = true;
        this.$refs.iocForm.option.column[13].display = true;
        this.$refs.iocForm.option.column[14].display = false;
        this.$refs.iocForm.option.column[15].display = false;
        this.$refs.iocForm.option.column[16].display = false;
      }
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    queryBuildingTree() {
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        // console.log(this.treeData);
        this.expandedKeys = [
          this.devInData.buildingId || this.devInData.buildingCode || this.treeData[0].id,
        ];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey({
            id: this.devInData.buildingCode || this.devInData.buildingId,
          });
        });
      });
    },
    //重置
    // clearSearch() {
    //   this.searchString = "";
    //   this.filterText();
    // },
    // 打开楼栋选择
    openBuilding() {
      this.showBuilding = true;
      if (this.devInData.fileCode) {
        this.rootDefaultDrawing = false;
      } else {
        this.rootDefaultDrawing = true;
      }
      this.imgUrl = this.getImgPath(this.devInData.fileCode);
      this.canvasList = [
        {
          abscissa: this.devInData.abscissa,
          ordinate: this.devInData.ordinate,
          width: this.devInData.width,
          height: this.devInData.height,
        },
      ];

      this.queryBuildingTree(); //楼栋树
      this.$nextTick(() => {
        this.clickPoints(); //画布添加事件
        this.getCanvasWH(); //回显打点
        let _this = this;
        window.onresize = function () {
          _this.watchScreen();
        };
      });
    },
    // 窗口改变事件
    watchScreen() {
      this.getCanvasWH();
    },
    // 点击节点
    nodeClick(data) {
      // type：-1 顶级，1 楼栋 2 楼层
      if (data.type != 2) {
        this.$message.warning("请将设备标记在楼层图纸上");
        return;
        //
      }
      // 清空已存在的数据和画布
      this.clearCanvas();
      this.x = "";
      this.y = "";
      this.canvasList = [];
      this.parentCode = data.parentCode;
      if (!data.fileCode) {
        this.rootDefaultDrawing = true;
      } else {
        this.rootDefaultDrawing = false;
        this.imgUrl = this.getImgPath(data.fileCode);
      }
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.parentName = item.parentName;
          entity.type = item.type; // type：-1 顶级，1 楼栋 2 楼层
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 画布添加点击事件
    clickPoints() {
      let that = this;
      let x, y;
      var canvas = document.getElementById("mycanvas");
      canvas.addEventListener("click", function (e) {
        clearInterval(that.handleClickTime);
        if (that.setTimeNum < 3) {
          // 超时默认移动事件
          that.showCamImg(e);
          this.setTimeNum = 0;
        }
      });
      canvas.addEventListener(
        "mousemove",
        function (e) {
          this.setTimeNum = 0;
          if (e.pageX || e.pageY) {
            x = e.offsetX;
            y = e.offsetY;
          } else {
            x =
              e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
          }
          that.x = x;
          that.y = y;
        },
        false
      );
      canvas.addEventListener(
        "mousedown",
        function (e) {
          that.setTimeNum = 0;
          if (that.handleClickTime) {
            clearInterval(that.handleClickTime);
          }
          that.handleClickTime = setInterval(() => {
            that.setTimeNum++;
          }, 100);
        },
        false
      );
    },
    // 获取canvas father W H
    getCanvasWH() {
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.mathCanvas();
    },
    // 画布点击回调
    showCamImg(e) {
      this.clearCanvas();
      let x = e.offsetX;
      let y = e.offsetY;
      this.canvasList = [
        {
          abscissa: x,
          ordinate: y,
          width: this.cW,
          height: this.cH,
        },
      ];
      this.x = x;
      this.y = y;
      this.mathCanvas();
    },
    mathCanvas() {
      this.clearCanvas();

      let img = this.tipImg[this.devInData.deviceType] || this.tipImg[10001];
      let ctx = this.initCanvas();
      // console.log(this.devInData.deviceType);
      if (this.canvasList.length) {
        this.canvasList.forEach((el) => {
          // 只渲染当前楼层点位
          // if (el.floorId != this.floorInfo.buildingCode) {
          //   return;
          // }
          let wb = this.cW / Number(el.width);
          let hb = this.cH / Number(el.height);
          this.$nextTick(() => {
            ctx.drawImage(
              img,
              Math.round(Number(el.abscissa) * wb - 25),
              Math.round(Number(el.ordinate) * hb - 25),
              50,
              50
            );
          });
        });
      }
    },
    // 画布确定回调
    camConfirmOpt() {
      let checkNode = this.$refs.tree.getCurrentNode();
      // console.log(checkNode);
      if (!checkNode || !checkNode.id || checkNode.type != 2) {
        this.$message.warning("请选择设备所属所属楼栋/楼层");
        return;
      }
      if (!this.canvasList.length) {
        this.$message.warning("请标记设备在图纸位置");
        return;
      }
      // type：-1 顶级，1 楼栋 2 楼层
      // buildingName
      this.devInData.buildingName = checkNode.name;
      this.devInData.buildingCode = checkNode.id; //必须传，选中节点id
      this.devInData.buildName =
        checkNode.type == 2 ? checkNode.parentName : checkNode.name; //楼栋名称
      this.devInData.buildingId =
        checkNode.type == 2 ? checkNode.parentCode : checkNode.id; //楼栋id
      this.devInData.floorId = checkNode.type == 2 ? checkNode.id : ""; //楼层id
      this.devInData.floorName = checkNode.type == 2 ? checkNode.name : ""; //楼层名称
      this.devInData.abscissa = this.canvasList[0].abscissa;
      this.devInData.ordinate = this.canvasList[0].ordinate;
      this.devInData.width = this.cW;
      this.devInData.height = this.cH;
      this.devInData.fileCode = this.fileCode;
      this.camCancelOpt();
    },
    camCancelOpt() {
      this.imgUrl = "";
      this.canvasList = [];
      this.showBuilding = false;
      this.rootDefaultDrawing = true;
      this.setTimeNum = 0;
      this.handleClickTime && clearInterval(this.handleClickTime);
      window.onresize = null;
    },
    validateForm() {
      return new Promise(this.$refs.iocForm.validate);
    },
    clearValidate() {
      this.$refs.iocForm.clearValidate();
    },
    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTrData = res.returnObj;
      });
    },
    selectAreaNode(data) {
      this.deviceTreeShow = false;
      this.devInData.areaName = data.areaDevGroupName;
      this.devInData.areaCode = data.areaDevGroupCode;
    },
    initMap() {
      // console.log(this.devInData);
      // this.$refs.refAppMap.setMapCenter();
      this.$refs.refAppMap.getLocation(this.getLocationCB);
      if (this.devInData.longitude) {
        let coord = [Number(this.devInData.longitude), Number(this.devInData.latitude)];
        this.$refs.refAppMap.setMapCenter(coord);
        this.getLocationCB(coord); //h回显已配置的点位
      } else {
        this.$refs.refAppMap.setMapCenter();
      }
      this.$refs.refAppMap.getAreaInfo();
    },
    getLocationCB(event) {
      let option = [
        {
          id: "point_" + new Date().getTime(),
          coord: [event[0], event[1]],
          src: "images/theme/newDark/map/resource/position_red.png",
          anchor: [10, 20],
        },
      ];
      this.point = [event[0], event[1]];
      this.$refs.refAppMap.removePoint("devicePointId");
      this.$refs.refAppMap.addMarket(option, "devicePointId");
    },
    openMap() {
      this.showMap = true;
      setTimeout(() => {
        this.initMap();
        // this.$map.showMap2D(this.initMap);
      }, 200);
    },
    mapClose() {
      // this.$map.hideMap2D();
    },
    // 点击地图框中的取消操作
    mapCancleOpt() {
      this.showMap = false;
      // this.$map.hideMap2D();
    },
    mapConfirmOpt() {
      this.devInData.longitude = Number(this.point[0]).toFixed(10);
      this.devInData.latitude = Number(this.point[1]).toFixed(10);
      this.showMap = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-container {
  width: 100%;
  height: 100%;

  .position-set {
    position: relative;
  }

  .map-choose {
    position: absolute;
    right: -5px;
    top: 0px;
  }

  .coord {
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 0%;
    min-width: 210px;
    background: rgba(13, 18, 28, 0.7);
    padding: 5px 10px;
    color: #fff;
  }

  .area-title {
    margin: 10px 0 16px 10px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    font-size: 14px;
    color: #e8eaee;
  }

  :deep .el-tree-node__content {
    height: 32px;
    line-height: 32px;
  }

  .area-search {
    margin: 12px;
  }

  #map-container {
    width: 100%;
    height: calc(100% - 30px);
  }

  .flex-container {
    display: flex;
    position: relative;

    .left-tree {
      // width: 45%;
      // float: left;
      // display: inline;
      flex: 1;
      height: 500px;
    }

    .right-img {
      margin-left: 12px;
      flex: 2;

      #building-img {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .canvasMain {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: rgba(128, 128, 128, 0.5);

      .canvasMainT {
        position: absolute;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }

        canvas {
          position: absolute;
        }
      }
    }
  }

  .buildingDialog-footer {
    margin-top: 30px;
  }
}
</style>
